import React from 'react'

import HealthMetricCardsSkeleton from './HealthMetricCardsSkeleton'
import MemberHealthListSkeleton from './MemberHealthListSkeleton'

const ProjectHealthContentSkeleton = () => (
    <>
        <HealthMetricCardsSkeleton />
        <MemberHealthListSkeleton />
    </>
)

export default ProjectHealthContentSkeleton
